import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import './HowWeWork.css';

const HowWeWork = ({ title = 'How We Work', steps }) => {
  if (!steps?.length) {
    return null;
  }

  return (
    <section className="how-we-work">
      <div className="how-we-work__inner">
        <Reveal>
          <h2 className="how-we-work__title">{title}</h2>
        </Reveal>

        <div className="how-we-work__steps">
          {steps.map(({ number, title: stepTitle, description }, index) => (
            <Reveal key={stepTitle} delay={index * 80} className="how-we-work__step">
              <p className="how-we-work__number">{number}</p>
              <h3 className="how-we-work__step-title">{stepTitle}</h3>
              <p className="how-we-work__step-text">{description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
